module.exports = __webpack_public_path__ + "static/media/icon_open_in_new.4c1b3b1f.svg";